<div
    class="booking-progress-summary-card"
    data-testid="storefront-booking-progress-summary"
>
    <button
        type="button"
        class="booking-progress-summary-back btn btn-outline-secondary d-inline-flex align-items-center gap-1 w-auto"
        data-testid="back-booking-step"
        aria-label="Back to previous booking step"
        [disabled]="backDisabled()"
        (click)="back.emit()"
    >
        <img
            src="assets/left/back.svg"
            width="20"
            height="20"
            alt=""
            aria-hidden="true"
        />
        <span>Back</span>
    </button>

    <div
        class="booking-progress-summary-row hstack gap-2 gap-md-3"
        role="group"
        aria-label="Selected booking options"
    >
        <span class="booking-progress-summary-item">
            <img
                class="booking-progress-summary-icon d-none d-md-inline-block"
                src="assets/people/normal.svg"
                width="20"
                height="20"
                alt=""
                aria-hidden="true"
            />
            <span class="visually-hidden">Party size:</span>
            <span>{{ search().partySize | i18nPlural: partySizePluralMapping }}</span>
        </span>

        <span
            class="booking-progress-summary-dot"
            aria-hidden="true"
        >
            &middot;
        </span>

        <span class="booking-progress-summary-item">
            <img
                class="booking-progress-summary-icon d-none d-md-inline-block"
                src="assets/dropdown-calendar.svg"
                width="20"
                height="20"
                alt=""
                aria-hidden="true"
            />
            <span class="visually-hidden">Date:</span>
            <span>{{ search().date | date:'EEE d MMM' }}</span>
        </span>

        <span
            class="booking-progress-summary-dot"
            aria-hidden="true"
        >
            &middot;
        </span>

        <span class="booking-progress-summary-item booking-progress-summary-time">
            <img
                class="booking-progress-summary-icon d-none d-md-inline-block"
                src="assets/dropdown-clock.svg"
                width="20"
                height="20"
                alt=""
                aria-hidden="true"
            />
            <span class="visually-hidden">Ideal time:</span>
            <span>{{ search().idealTime | date:'shortTime' }}</span>
        </span>
    </div>

    <span aria-hidden="true"></span>
</div>
